import { Tag, Tooltip, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { formatDate } from 'utils/formatDate';

// Canonical event type keys (investcore model/stock_event.go), each with the
// Wifeed label it is derived from.
export const EVENT_TYPES = [
  { value: 'cash_dividend', label: 'Trả cổ tức bằng tiền mặt', color: 'green' },
  { value: 'stock_dividend', label: 'Trả cổ tức bằng cổ phiếu', color: 'cyan' },
  { value: 'stock_bonus', label: 'Thưởng cổ phiếu', color: 'gold' },
  { value: 'additional_issuance', label: 'Phát hành thêm', color: 'purple' },
  { value: 'agm', label: 'Họp ĐHCĐ thường niên', color: 'blue' },
  {
    value: 'agm_failed',
    label: 'Họp ĐHCĐ thường niên (Bất thành)',
    color: 'red',
  },
  { value: 'egm', label: 'Họp ĐHCĐ bất thường', color: 'geekblue' },
  {
    value: 'written_opinion',
    label: 'Lấy ý kiến CĐ bằng văn bản',
    color: 'orange',
  },
  { value: 'other', label: 'Khác', color: 'default' },
];

const EVENT_TYPE_BY_KEY = Object.fromEntries(
  EVENT_TYPES.map(t => [t.value, t])
);

export const EVENT_TYPE_OPTIONS = EVENT_TYPES.map(({ value, label }) => ({
  value,
  label: `${label} (${value})`,
}));

// Wifeed label for a type key; undefined for `other` and unknown keys.
export const eventTypeLabel = key =>
  key && key !== 'other' ? EVENT_TYPE_BY_KEY[key]?.label : undefined;

export const renderEventType = value =>
  value ? (
    <Tag color={EVENT_TYPE_BY_KEY[value]?.color || 'default'}>{value}</Tag>
  ) : null;

export const columnsGenerator = params => [
  {
    title: '',
    dataIndex: 'id',
    align: 'center',
    render: id => (
      <Link to={`/catalog/stock-events/${id}`} state={params?.linkState}>
        View
      </Link>
    ),
  },
  {
    title: 'Symbol',
    dataIndex: 'symbol',
    render: value => <Tag color="blue">{value}</Tag>,
  },
  {
    title: 'Event',
    dataIndex: 'event_type_label',
  },
  {
    title: 'Event Type',
    dataIndex: 'event_type',
    render: renderEventType,
  },
  {
    title: 'Title',
    dataIndex: 'title',
    width: 320,
    render: value =>
      value ? (
        <Tooltip title={value}>
          <Typography.Paragraph ellipsis={{ rows: 2 }} style={{ margin: 0 }}>
            {value}
          </Typography.Paragraph>
        </Tooltip>
      ) : (
        '-'
      ),
  },
  {
    title: 'Announce Date',
    dataIndex: 'announce_date',
    render: value => formatDate(value) || '-',
  },
  {
    title: 'Record Date',
    dataIndex: 'record_date',
    render: value => formatDate(value) || '-',
  },
  {
    title: 'Execute Date',
    dataIndex: 'execute_date',
    render: value => formatDate(value) || '-',
  },
];
